import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=49d0ffec&"
import script from "./nav-menu.vue?vue&type=script&lang=ts&"
export * from "./nav-menu.vue?vue&type=script&lang=ts&"
import style0 from "./nav-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports